var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74961 14.2333C3.57183 14.2333 3.41905 14.1694 3.29128 14.0416C3.1635 13.9138 3.09961 13.7611 3.09961 13.5833V3.08329C3.09961 2.90551 3.1635 2.74996 3.29128 2.61663C3.41905 2.48329 3.57183 2.41663 3.74961 2.41663H8.71628C8.87183 2.41663 9.00794 2.46663 9.12461 2.56663C9.24128 2.66663 9.31628 2.79996 9.34961 2.96663L9.56628 3.84996H12.9163C13.0941 3.84996 13.2496 3.91663 13.3829 4.04996C13.5163 4.18329 13.5829 4.33885 13.5829 4.51663V9.84996C13.5829 10.0277 13.5163 10.1805 13.3829 10.3083C13.2496 10.4361 13.0941 10.5 12.9163 10.5H9.39961C9.24405 10.5 9.10794 10.4527 8.99128 10.3583C8.87461 10.2638 8.79961 10.1388 8.76628 9.98329L8.54961 9.08329H4.41628V13.5833C4.41628 13.7611 4.35239 13.9138 4.22461 14.0416C4.09683 14.1694 3.9385 14.2333 3.74961 14.2333Z",
    fill: "#DD0404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.35abf94b695f80972eda8f141bc945e9.svg";
export { ForwardRef as ReactComponent };